import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useFetch } from "../hooks/useFetch";
import { Skeleton } from "@material-ui/lab";

interface ScholarshipStatusSelectorProps {
    scholarshipStatusId: number
    setScholarshipStatusId: (value: number) => void;
    setIsCompleted: (value: boolean) => void;
    loading?: boolean;
}

interface ScholarshipStatus {
    id: number;
    status: string;
}


export default function ScholarshipStatusSelector({ scholarshipStatusId, setIsCompleted, setScholarshipStatusId, loading }: ScholarshipStatusSelectorProps) {
    const [cookies] = useCookies(['user']);
    const [scholarshipStatuses, setScholarshipStatuses] = useState<ScholarshipStatus[]>([]);

    const { data: getScholarshipStatusesData, error: getScholarshipStatusesError, loading: getScholarshipStatusesLoading } = useFetch({
        url: "/ScholarshipStatuses",
        method: "GET",
        headers: {
            'Authorization': `Bearer ${cookies?.user?.token}`,
        },
    });

    useEffect(() => {
        if (getScholarshipStatusesData) {
            setScholarshipStatuses(getScholarshipStatusesData);
        }
    }, [getScholarshipStatusesData]);

    useEffect(() => {
        if (scholarshipStatusId === 1) {
            setIsCompleted(false);
        } else {
            setIsCompleted(true);
        }
    }, [scholarshipStatusId]);

    const handleOnSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedStatusId = Number(e.target.value);
        setScholarshipStatusId(selectedStatusId);
    }

    return (
        (getScholarshipStatusesLoading) ? (
            <Skeleton variant="rect" width={200} height={26} />
        ): (
            <div className="ProgressDialog-scholarship-status-container flex gap-dot5" >
                <label htmlFor="scholarshipStatus">สถานะทุน:</label>
                <select name="scholarshipStatus" id="scholarshipStatus" value={scholarshipStatusId} onChange={handleOnSelectChange} disabled={loading}>
                    {
                        scholarshipStatuses.map((scholarshipStatus) => {
                            return (
                                <option key={scholarshipStatus.id} value={scholarshipStatus.id}>
                                    {scholarshipStatus.status}
                                </option>
                            )
                        })
                    }
                </select>
            </div>
        )
    );
}